import React from 'react';
import { useRecoilValue } from 'recoil';
import { Box, Card, CardContent, CardHeader, Grid, Link } from '@mui/material';
import { CarModel } from 'models/StockModel';
import { CompanyType } from 'models/CompanyModel';
import InstantChatButton from 'modules/chats/common/InstantChatButton';
import auth from 'recoil/atoms/auth';


type CompanyCardProps = {
    car: CarModel,
}

const CompanyCard = ({ car }: CompanyCardProps) => {
    const my = useRecoilValue(auth);

    if (my.type === CompanyType.Shipper)
        return (
            <Card sx={{mb: 2}}>
                    <Grid container justifyContent="space-between">
                        <Grid item>

                        </Grid>
                        <Grid item>
                            <InstantChatButton
                                code={`car:${car.id}`}
                                name={`${car.model} ${car.chassisNumber} (${car.company.name})`}
                            />
                        </Grid>
                    </Grid>
            </Card>
        );

    return (
        <Card sx={{mb: 2}}>
            <CardHeader
                title={car.company.name}
                action={my.type === CompanyType.Master && <InstantChatButton
                    code={`car:${car.id}`}
                    name={`${car.model} ${car.chassisNumber} (${car.company.name})`}
                />}
            />
            <CardContent>
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <Link component="a" href={`tel:${car.company.phone}`}>{car.company.phone}</Link>
                    </Grid>
                    <Grid item display="flex" flexDirection="column" justifyContent="flex-end">
                        <Link component="a" href={`mailto:${car.company.email}`}>{car.company.email}</Link>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default CompanyCard;
